import { render, staticRenderFns } from "./PurchaseRequestFilters.vue?vue&type=template&id=4b06d7e8&"
import script from "./PurchaseRequestFilters.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestFilters.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestFilters.vue?vue&type=style&index=0&id=4b06d7e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports